import axios from 'axios'
import jwtDecode from 'jwt-decode'
const baseUrl = '/api/user/'


const headers = {
    'Content-Type': 'application/json'
}

const refreshTheToken = async () => {
    console.log("Refreshing the token")
    return regenerateToken().then(x => {
      console.log("FOUND REFRESH Private")
      const {accessToken} = x
      return accessToken
    })
}

const checkAuthorization = async (token) => {
    console.log("Checking authorization")
    if(token){
        let {exp} = jwtDecode(token)
        let dateNow = new Date();
        if(exp < dateNow.getTime()/1000) {
            try{
                const accessT = await refreshTheToken()
                console.log("from private route", accessT)
                if (accessT) {
                    console.log("retried to fetch refresh token successfully", accessT)
                    return accessT
                }else{
                    return null
                }
            }catch(err){
                console.error("problem with refresh token, sign in again ")
                return null
            }
           
        }else{
            console.log("Not access expired")
            return token
        }
    }else{
        //console.log("in the false")
        return null
    }
}


const registerUser = async (registeredUser) => {
    //console.log("Registering user", registeredUser)
    const res = await axios.post(`${baseUrl}signup`, registeredUser,
    {
        headers : headers
    }
    
    ).then(resp => resp.data)

}

const loginUser = async(user) => {
    //console.log("Loggin in user", user)
    const req =  axios.post(`${baseUrl}login`, user,
        {
            headers : headers
        }
    )

    return req.then(x => x.data).catch(err => {
        console.log("Error logging in uer", err)
        if(err.response){
            console.log("the data", err.response.data.error)
            const message =  `Error Occured: ${err.response.data.error}`
            throw new Error(message)
        }
        
    })
}

const uploadUserAvatar = async (accessToken,file) => {
    const data = new FormData();
    console.log("the file", file)
    console.log("avatar token", accessToken)
    data.append("image", file)
    
    const req = axios.post(`${baseUrl}avatarupload`, data, {
        headers: {
            "authorization" : `Bearer ${accessToken}`
        }
    })

    return req.then(req => req)
}

const uploadWardrobeItemImg = async (accessToken,file) => {
    const data = new FormData();
    console.log("the file", file)
    console.log("wardrobe token", accessToken)
    data.append("image", file)
    let t = await checkAuthorization(accessToken)

    // if (t != null){
    //     const req = axios.post(`${baseUrl}wardrobeitemimage`, data, {
    //         headers: {
    //             "authorization" : `Bearer ${t}`
    //         }
    //     })
    //     return req.then(req => req)
    // }else {
    //     return null
    // }

    const req = axios.post(`${baseUrl}wardrobeitemimage`, data, {
        headers: {
            "authorization" : `Bearer ${t}`
        }
    })
    return req.then(req => req)
}

const uploadWardrobeItem = async (accessToken, data) => {
    let t = await checkAuthorization(accessToken)
    if(t != null) {
        const req = axios.post(`${baseUrl}wardrobeitemupload`,data, {
            headers: {
                "authorization" : `Bearer ${t}`
            }
        })
        return req.then(req => req.data)
    }else{
        console.log("UPLOADING WARDROBE ITEM NO TOKEN")
        return null
    }
}

const getUserWardrobe = async (accessToken) => {
    console.log("getting wardrobe data ")
    const req = axios.get(`${baseUrl}userswardrobe`, {
        headers: {
            "authorization" : `Bearer ${accessToken}`
        }
    })
    return (await req).data
}


const regenerateToken = async() => {
    console.log("regenerating token")
    const req = axios.post(`${baseUrl}token`,{withCredentials: true},
        {
            headers : headers
        }
    )
    return req.then(req => req.data)
}

const accessProtectedRoute = async (accessToken) => {
    console.log("Requesting social feed data")
    const req = axios.post(`/api/social/socialfeed`, {withCredentials: true}, {
        headers: {
            "authorization" : `Bearer ${accessToken}`
        }
    })
}


const getMe = async (accessToken) => {
    //console.log("Requesting social profile data")
    const req = axios.get(`${baseUrl}getMe`, {
        headers: {
            "authorization" : `Bearer ${accessToken}`
        }
    })
    return (await req).data
}


export default {
    registerUser : registerUser,
    loginUser : loginUser,
    regenerateToken : regenerateToken,
    accessProtectedRoute : accessProtectedRoute,
    getMe : getMe,
    uploadUserAvatar : uploadUserAvatar,
    uploadWardrobeItemImg :uploadWardrobeItemImg,
    uploadWardrobeItem : uploadWardrobeItem,
    getUserWardrobe : getUserWardrobe
    
}